import { createAction } from '../../utils/redux/createAction';

const actionsScope = 'appointment-form/overlap-modal';

export const OVERLAP_MODAL = {
  OPEN: `${actionsScope}/open`,
  CLOSE: `${actionsScope}/close`,
};

export const overlapModalActions = {
  open: createAction(OVERLAP_MODAL.OPEN),
  close: createAction(OVERLAP_MODAL.CLOSE),
};

const initialState = {
  opened: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case OVERLAP_MODAL.OPEN: {
      return {
        opened: true,
        entity: payload,
      };
    }

    case OVERLAP_MODAL.CLOSE: {
      return {
        ...state,
        opened: false,
      };
    }

    default: {
      return state;
    }
  }
};



// WEBPACK FOOTER //
// ./src/redux/appointmentForm/overlap-modal.js